const FEATURES = [
  {
    icon: 'ri-flashlight-line',
    title: '实时追踪',
    desc: '全天候监控全网热点，第一时间推送最新八卦动态，让你永远站在吃瓜第一线。',
    color: 'primary',
  },
  {
    icon: 'ri-database-2-line',
    title: '海量归档',
    desc: '收录数万条历史八卦，按人物、事件、时间多维度整理，旧瓜新吃随时回顾。',
    color: 'accent',
  },
  {
    icon: 'ri-group-line',
    title: '吃瓜社区',
    desc: '千万吃瓜群众在线交流，热门评论、神回复不断，吃瓜体验不止于阅读。',
    color: 'secondary',
  },
  {
    icon: 'ri-shield-check-line',
    title: '可信来源',
    desc: '多渠道交叉验证，杜绝虚假信息，只为你呈现有据可查的真实八卦内幕。',
    color: 'primary',
  },
];

export default function Features() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-3">
            为什么选择我们
          </span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">平台特色</h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {FEATURES.map((f) => {
            const colorMap: Record<string, { bg: string; icon: string; border: string }> = {
              primary: { bg: 'bg-primary-50', icon: 'text-primary-600', border: 'border-primary-200/60' },
              accent: { bg: 'bg-accent-50', icon: 'text-accent-600', border: 'border-accent-200/60' },
              secondary: { bg: 'bg-secondary-50', icon: 'text-secondary-600', border: 'border-secondary-200/60' },
            };
            const c = colorMap[f.color] || colorMap.primary;
            return (
              <div
                key={f.title}
                className={`group p-6 rounded-xl ${c.bg} border ${c.border} transition-all duration-300 hover:-translate-y-1`}
              >
                <div className={`w-11 h-11 flex items-center justify-center rounded-lg ${c.icon} bg-white/70 mb-4`}>
                  <i className={`${f.icon} text-xl`}></i>
                </div>
                <h3 className="font-heading text-lg text-foreground-900 mb-2">{f.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{f.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}